import { Parameters } from '@app/models/Parameters';
import { post, get } from './http.api';
import { DepartmentRequest } from '@app/models/departments/DepartmentRequest';
import {
  DepartmentTableData,
  DepartmentTableRow,
  DepartmentResponse,
  DepartmentApiData,
} from '@app/models/departments/DepartmentResponse';

export const getDepartmentTableData = async (parameters: Parameters): Promise<DepartmentTableData> => {
  try {
    const { data, status } = await get<any>('departments', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data:`, data);

    const Departments: DepartmentTableRow[] = data?.departments?.data?.map((DepartmentData: any) => ({
      id: DepartmentData.id,
      code: DepartmentData.code,
      name: DepartmentData.name,
    }));

    return {
      data: Departments,
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
    };
  } catch (error: any) {
    console.error('Error fetching Departments:', error);
    throw error;
  }
};

export const getAllDepartments = async (): Promise<DepartmentResponse> => {
  try {
    const { data, status } = await get<DepartmentResponse>(`departments`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getDepartmentById = async (id: number): Promise<DepartmentResponse> => {
  try {
    const { data, status } = await get<DepartmentResponse>(`departments/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeDepartment = async (DepartmentData: DepartmentRequest) => {
  try {
    const response = await post<any>('departments/create', DepartmentData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createDepartment = async (): Promise<DepartmentApiData> => {
  try {
    const { data, status } = await get<DepartmentApiData>(`departments/create`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showDepartment = async (id: number) => {
  try {
    const { data, status } = await get<DepartmentApiData>(`departments/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editDepartment = async (id: number) => {
  try {
    const { data, status } = await get<DepartmentApiData>(`departments/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateDepartment = async (id: number, Updatecategory: DepartmentRequest) => {
  try {
    const { data, status } = await post<DepartmentRequest>(`departments/${id}/edit`, Updatecategory, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};
